<template>
    <div class="s-3-bmargin">

        <p class="s-bit-smaller">Consulter l’état des données dans le temps&nbsp;:</p>

        <div class="row">
            <datepicker
                class="col-sm-5 col-sm-4 col-lg-3"
                placeholder="Choisir une date limite"
                name="uniquename"
                format="yyyy-MM-dd"
                language="fr"
                :clear-button="true"
                :calendar-button="true"
                :bootstrap-styling="true"
                :disabled="state.disabled"
                :value="state.date"
                @input="onChange"
            />

            <div class="col-sm-7 col-md-8 col-lg-9">
                <button v-if="state.displayButtons" @click.prevent="submit" class="btn btn-default btn--front-blue">Rafraîchir</button>
            </div>

        </div>

    </div>
</template>

<script>
    import { isNil, isDate } from 'lodash';

    export default {
        name: 'MaxDate',

        props: {
            value: {
                type: String,
            },
            baseUrl: {
                type: String,
            },
            limit: {
                type: String,
            },
        },

        data() {
            return {
                state: {
                    date: null,
                    displayButtons: false,
                    disabled: {
                        from: new Date(),
                    },
                },
            };
        },

        created()
        {
            const props = this.$options.propsData;
            this.state.date = !isNil(props.value) ? new Date(props.value + 'T12:00:00.000Z') : null;
            this.state.disabled.from = !isNil(props.limit) ? new Date(props.limit + 'T23:59:59.000Z') : new Date();
        },

        methods: {
            onChange(d) {
                this.state.date = d;
                this.state.displayButtons = true;
            },

            submit() {
                if (isDate(this.state.date)) {
                    document.location.href = this.baseUrl + '/' + this.formatDate(this.state.date);
                }
                else
                {
                    document.location.href = this.baseUrl;
                }
            },

            formatDate(date) {
                const year = date.getFullYear();
                let month = date.getMonth() + 1;
                let day = date.getDate();

                month = `${month}`;
                if (month.length < 2) {
                    month = `0${month}`;
                }
                day = `${day}`;
                if (day.length < 2) {
                    day = `0${day}`;
                }

                return `${year}-${month}-${day}`;
            }

        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/vue/max-date.vue